function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.2 24h-.5C10.2 24 9 22.8 9 21.2v-6.1H2.8c-1.5 0-2.8-1.2-2.8-2.8v-.6C0 10.2 1.2 9 2.8 9H9V2.8C9 1.2 10.2 0 11.7 0h.5C13.8 0 15 1.2 15 2.8V9h6.2c1.5 0 2.8 1.2 2.8 2.8v.6c0 1.5-1.2 2.8-2.8 2.8H15v6.1c0 1.5-1.2 2.7-2.8 2.7z",
  fill: "#231F20",
  fillRule: "nonzero"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgComponent;